import React, { Component } from 'react'
import './errorPage.less'
import { Button } from 'antd'

export default class Page403 extends Component {
  render() {
    return (
      <div className="error-page-layout">
        <div className="error-img">
          <img src="/extendicon/img/403.png" style={{
            width: '521px',
            height: '490px'
          }} />
        </div>
        <div className="error-page-content">
          <div>
            <div className="error-page-font1-403">403</div>
            <div className="error-page-font2">很抱歉！您无权访问该页面</div>
            <div className="error-page-font3">如果您想继续访问，请联系管理员</div>
            <Button type="primary" style={{ marginBottom: '109px' }}>返回首页</Button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Demo/errorPage/Page403.tsx